const SkeletonProcess = () => {
  return (
    <>
      <div className="card card-border-left p-1 p-md-5">
        <div className="row">
          <div className="col-md-6">
            <svg
              aria-label="Placeholder"
              className="bd-placeholder-img img-fluid rounded"
              preserveAspectRatio="xMidYMid slice"
              role="img"
              height="300"
              width="100%"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="100%" height="100%" fill="#868e96"></rect>
            </svg>
          </div>
          <div className="col-md-6 d-flex flex-column">
            <div className="card-header">
              <div className="placeholder-glow">
                <span className="placeholder col-2"></span>
              </div>
              <div className="card-title placeholder-glow mt-2">
                <span className="placeholder col-8 py-3"></span>
              </div>
            </div>
            <div className="d-none d-md-block card-body placeholder-glow">
              <p className="card-text d-flex flex-column gap-2 placeholder-glow">
                <span className="placeholder col-7 mb-3"></span>
                <span className="placeholder col-12"></span>
                <span className="placeholder col-12"></span>
                <span className="placeholder col-12"></span>
                <span className="placeholder col-3 mb-3"></span>
                <span className="placeholder col-5"></span>
              </p>
            </div>
            <div className="card-footer mt-auto">
              <a
                className="btn btn-secondary disabled placeholder col-3"
                aria-disabled="true"
              ></a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SkeletonProcess;
